<template>
  <div id="content-atividade">
    <div id="top-content-atividade">
      <Breadcrumb :items="breadcrumbItems" />
      <Carregamento v-if="carregando" />

      <div v-if="!carregando && atividade" id="titulo-e-acoes">
        <div id="titulo-atividade">
          <div class="status-badge-wrapper">
            <span v-if="badgeStatus" class="status-atividade" :class="badgeStatus.classe">
              <i class="ti" :class="badgeStatus.icone"></i> {{ badgeStatus.texto }}
            </span>
            <span v-if="mostrarBadgeInscricoesEncerradas" class="status-atividade inscricoes-encerradas">
              <i class="ti ti-calendar-off"></i> Inscrições encerradas
            </span>
          </div>

          <h2>{{ dadosAtividade.nome }}</h2>
        </div>

        <div class="header-actions">
          <div v-if="isInscrito" class="inscricao-topo-container">
            <span class="badge-inscrito-topo">
              <i class="ti ti-circle-check"></i> Você está inscrito(a)
            </span>
            <button v-if="podeCancelarInscricao" class="btn btn-pequeno btn-perigo"
              @click="abrirModalCancelarInscricao">
              <i class="ti ti-user-x"></i> Cancelar inscrição
            </button>
          </div>

          <button v-else-if="podeSeInscrever" class="btn btn-destaque" :disabled="inscrevendo"
            @click="realizarInscricao">
            <i class="ti ti-ticket"></i> {{ inscrevendo ? "Inscrevendo..." : "Inscrever-se" }}
          </button>




        </div>
      </div>
    </div>

    <div v-if="!carregando && atividade" id="conteudo">
      <section id="superior">
        <!-- Coluna esquerda: imagem + formulário da coordenação + ações do coordenador -->
        <div id="esquerda">
          <div id="img">
            <figure>
              <img :src="imagemAtividade" :alt="dadosAtividade.nome" @error="aoFalharImagem" />
            </figure>
          </div>

          <div v-if="
            dadosAtividade.linkFormulario ||
            isCoordenadorAcao ||
            mostrarAcoesCoordenador
          " id="acoes-coordenador">
            <h6 class="rotulo-secao">AÇÕES DA COORDENAÇÃO</h6>

            <div id="opcoes">
              <!-- Formulário da coordenação -->
              <a v-if="dadosAtividade.linkFormulario" :href="formatarUrlExterna(dadosAtividade.linkFormulario)"
                target="_blank" rel="noopener noreferrer" class="btn btn-primario">
                <i class="ti ti-external-link"></i>
                Acessar formulário
              </a>

              <!-- Inscritos -->
              <button v-if="isCoordenadorAcao" class="btn btn-primario" @click="verInscritos">
                <i class="ti ti-users"></i>
                Ver lista de inscritos
              </button>

              <!-- Frequência -->
              <button v-if="podeRealizarFrequencia" class="btn btn-primario" @click="abrirModal('realizarFrequencia')">
                <i class="ti ti-clipboard-check"></i>
                Realizar frequência
              </button>

              <!-- Mapa de frequência -->
              <button v-if="podeBaixarMapaFrequencia" class="btn btn-primario" :disabled="baixandoMapa"
                @click="baixarMapaFrequencia">
                <i :class="baixandoMapa ? 'ti ti-loader-2' : 'ti ti-file-download'"></i>
                {{ baixandoMapa ? "Baixando..." : "Mapa Frequência" }}
              </button>

              <!-- Escolher participantes -->
              <button v-if="podeEscolherParticipantes" class="btn btn-primario" @click="verInscritos">
                <i class="ti ti-user-check"></i>
                Escolher participantes
              </button>

              <!-- Criar equipe -->
              <button v-if="podeCriarEquipe" class="btn btn-primario" @click="editarCargos = true">
                <i class="ti ti-users-group"></i>
                Criar equipe
              </button>

              <!-- Concluir atividade -->
              <button v-if="podeConcluirAtividade" class="btn btn-sucesso" :disabled="processandoAcao"
                @click="abrirModalConcluirAtividade">
                <i class="ti ti-circle-check"></i>
                Concluir atividade
              </button>

              <!-- Botões do coordenador para atividade encerrada -->
              <div v-if="coordenador && statusEfetivo === 'ENCERRADA'" id="botoes-coordenador-encerrada">
                <button class="btn btn-primario" :disabled="baixandoCsv" @click="baixarCsvFrequencia">
                  <i :class="baixandoCsv ? 'ti ti-loader-2' : 'ti ti-file-spreadsheet'"></i>
                  {{ baixandoCsv ? "Baixando..." : "CSV Frequência" }}
                </button>
              </div>

              <!-- Edição e cancelamento -->
              <div v-if="mostrarBotoesEdicao" id="botoes-coordenador">
                <button v-if="statusEfetivo !== 'EM_EXECUCAO'" class="btn btn-primario" @click="editarAtividade">
                  <i class="ti ti-edit"></i>
                  Editar atividade
                </button>

                <button class="btn btn-perigo" :disabled="processandoAcao" @click="abrirModalCancelarAtividade">
                  <i class="ti ti-ban"></i>
                  Cancelar atividade
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna direita: informações -->
        <div id="direita">
          <div id="infos">
            <h6 class="rotulo-secao">INFORMAÇÕES</h6>

            <div class="infos-grid">

              <!--Ação responsável-->
              <div v-if="nomeAcaoResponsavel" class="info-item">
                <div class="info-label">
                  <i class="ti ti-clipboard-check"></i>
                  Ação responsável
                </div>
                <div class="info-value">
                  <RouterLink v-if="acaoIdAlvo" :to="`/acao/${acaoIdAlvo}/informacoes`" class="link-acao-responsavel"
                    title="Ver detalhes da ação">
                    <span>{{ nomeAcaoResponsavel }}</span>
                    <i class="ti ti-arrow-up-right link-acao-icone"></i>
                  </RouterLink>
                  <span v-else>{{ nomeAcaoResponsavel }}</span>
                </div>
              </div>

              <!--Tipo de atividade-->
              <div class="info-item">
                <div class="info-label">
                  <i class="ti ti-category"></i>
                  Tipo de atividade
                </div>
                <div class="info-value">
                  {{ formatarEnum(nomeSubtipo) || "Não informado" }}
                </div>
              </div>

              <!-- Período de inscrições: sempre visível, independentemente do status -->
              <div class="info-item">
                <div class="info-label">
                  <i class="ti ti-calendar-time"></i>
                  Período de inscrições
                </div>

                <div class="info-value">
                  <div>
                    Início: {{ dadosAtividade.dataInicioInscricao
                      ? formatarDataHora(dadosAtividade.dataInicioInscricao)
                      : "Não informado" }}
                  </div>

                  <div>
                    Encerramento: {{ dadosAtividade.dataFimInscricao
                      ? formatarDataHora(dadosAtividade.dataFimInscricao)
                      : "Não informado" }}
                  </div>
                </div>
              </div>

              <!-- tipo de Inscrição -->
              <div v-if="dadosAtividade.modalidadeInscricao" class="info-item">
                <div class="info-label">
                  <i class="ti ti-file-text"></i>
                  tipo de Inscrição
                </div>
                <div class="info-value">{{ textoInscricao }}</div>
              </div>

              <!-- Total de vagas -->
              <div class="info-item">
                <div class="info-label">
                  <i class="ti ti-users"></i>
                  Total de vagas
                </div>
                <div class="info-value">
                  {{ totalVagasTexto }}
                </div>
              </div>

              <!-- Vagas restantes -->
              <div v-if="mostrarVagasRestantes" class="info-item">
                <div class="info-label">
                  <i class="ti ti-user-check"></i>
                  Vagas restantes
                </div>

                <div class="info-value">
                  <span v-if="isCriterioCoordenacao">
                    Seleção da coordenação
                  </span>

                  <span v-else-if="isVagasEsgotadas" class="vagas-esgotadas">
                    Vagas esgotadas
                  </span>

                  <span v-else>
                    {{ vagasRestantesTexto }}
                  </span>
                </div>
              </div>

              <!-- Modalidade de execução -->
              <div class="info-item">
                <div class="info-label">
                  <i class="ti ti-route"></i>
                  Modalidade de execução
                </div>
                <div class="info-value">
                  {{ formatarEnum(dadosAtividade.modalidadeExecucao) }}
                  <p v-if="coordenador && rotuloModalidadeInscricao" class="info-complemento">
                    Modalidade de inscrição: {{ rotuloModalidadeInscricao }}
                  </p>
                </div>
              </div>

              <!-- Período de realização -->
              <div class="info-item">
                <div class="info-label">
                  <i class="ti ti-calendar-event"></i>
                  Período de realização
                </div>
                <div class="info-value">{{ periodoRealizacao }}</div>
              </div>

              <!-- Local -->
              <div class="info-item info-item-local">
                <div class="info-label">
                  <i class="ti ti-map-pin"></i>
                  <span>Local</span>
                  <button v-if="temCoordenadas" class="btn-tela-cheia-mapa" title="Abrir mapa em tela cheia"
                    @click="abrirMapaTelaCheia">
                    <i class="ti ti-maximize" style="color: white;"></i>
                    Ver local no mapa
                  </button>
                </div>
                <div class="info-value">
                  {{ dadosAtividade.localLabel || "Não informado" }}
                </div>
                <div class="info-value">
                  {{ dadosAtividade.local || "Não informado" }}
                </div>
              </div>

              <!-- Como funciona a inscrição: sempre visível, independentemente do status -->
              <div class="info-item">
                <div class="info-label">
                  <i class="ti ti-info-circle"></i>
                  Como funciona a inscrição
                </div>

                <div class="info-value info-explicacao-texto">
                  {{ explicacaoInscricao }}
                </div>
              </div>





            </div>
          </div>
        </div>
      </section>

      <section id="inferior">
        <div id="descricao">
          <!-- Se a descrição puder ser escrita por usuários, sanitize com DOMPurify antes do v-html -->
          <span id="conteudo-descricao" v-html="dadosAtividade.descricao"></span>
        </div>

        <EncontrosListagemAtividade :key="versaoEncontros" :coordenador="coordenador" :dadosAtividade="dadosAtividade"
          :viaAcao="viaAcao" :podeVerInscritos="podeVerInscritos"
          :isPeriodoInscricaoEncerrado="isPeriodoInscricaoEncerrado" @abrir-modal-fotos="abrirModalFotos"
          @atualizar-encontros="buscarEncontros" />

        <div v-if="statusEfetivo !== 'CANCELADA'" id="objetivos-relacionados">
          <h6 class="rotulo-secao">OBJETIVO(S) RELACIONADO(S)</h6>

          <template v-if="dadosAtividade.objetivos?.length">
            <div v-for="obj in dadosAtividade.objetivos" :key="obj.id" class="objetivo-relacionado-item">
              <p class="objetivo-titulo">{{ obj.titulo }}</p>
            </div>
          </template>
          <p v-else class="objetivos-vazio">Nenhum objetivo relacionado encontrado.</p>
        </div>


      </section>
    </div>

    <!-- Falha ao carregar -->
    <div v-if="!carregando && !atividade" class="confirmacao confirmacao-erro">
      <div class="confirmacao-texto-bloco">
        <p class="confirmacao-titulo"><i class="ti ti-alert-circle"></i> Não foi possível carregar a atividade</p>
        <p class="confirmacao-subtexto">Verifique sua conexão e tente novamente.</p>
      </div>
      <button class="btn btn-primario" @click="inicializar">Tentar novamente</button>
    </div>

    <!-- Banners de status -->
    <template v-if="!carregando && atividade">
      <div v-if="statusEfetivo === 'CANCELADA'" class="confirmacao">
        <p class="confirmacao-mensagem">A atividade foi cancelada em {{ dataCancelamentoTexto }}</p>
      </div>

      <div v-if="statusEfetivo === 'ENCERRADA'" class="confirmacao">
        <p class="confirmacao-mensagem">Esta atividade foi encerrada dia {{ dataEncerramentoTexto }}.</p>
      </div>

      <div v-if="mostrarBannerInscrito" class="confirmacao confirmacao-inscrito">
        <div class="confirmacao-texto-bloco">
          <p class="confirmacao-titulo">
            <i class="ti ti-circle-check"></i> Você já está inscrito(a) nesta atividade!
          </p>
          <p v-if="subtextoInscrito" class="confirmacao-subtexto">{{ subtextoInscrito }}</p>
        </div>
        <button v-if="podeCancelarInscricao" class="btn btn-perigo-suave" @click="abrirModalCancelarInscricao">
          <i class="ti ti-user-x"></i> Cancelar inscrição
        </button>
      </div>

      <div v-if="mostrarBannerInscricoesEncerradas" class="confirmacao confirmacao-inscricoes-encerradas">
        <div class="confirmacao-texto-bloco">
          <p class="confirmacao-titulo"><i class="ti ti-calendar-off"></i> Período de inscrições encerrado</p>
          <p class="confirmacao-subtexto">
            As inscrições para esta atividade foram encerradas em
            {{ formatarDataHora(dadosAtividade.dataFimInscricao) }}.
          </p>
        </div>
      </div>

      <div v-if="emExecucao" class="confirmacao">
        <p class="confirmacao-mensagem">A atividade está em execução</p>
      </div>

      <div v-if="mostrarBannerProgramada" class="confirmacao">
        <p class="confirmacao-mensagem">{{ textoBannerProgramada }}</p>
      </div>

      <div v-if="concluida" class="confirmacao">
        <p class="confirmacao-mensagem">A atividade foi concluída em {{ dataConclusaoTexto }}</p>
      </div>

      <template v-if="mostrarBannerInscricoesAbertas">
        <div v-if="semInscricao" class="confirmacao">
          <p class="confirmacao-mensagem">A atividade está aberta para inscrições</p>
        </div>

        <div v-else class="confirmacao confirmacao-aberta">
          <div v-if="isVagasEsgotadas" class="confirmacao-texto-bloco">
            <p class="confirmacao-titulo confirmacao-titulo-alerta">
              <i class="ti ti-alert-circle"></i> Vagas esgotadas!
            </p>
            <p class="confirmacao-subtexto">
              Todas as vagas disponíveis para esta atividade foram preenchidas.
            </p>
          </div>

          <div v-else class="confirmacao-texto-bloco">
            <p class="confirmacao-titulo">A atividade está com inscrições abertas!</p>
            <p v-if="explicacaoInscricao" class="confirmacao-subtexto">{{ explicacaoInscricao }}</p>
          </div>

          <button v-if="podeSeInscrever" class="btn btn-destaque" :disabled="inscrevendo" @click="realizarInscricao">
            <i class="ti ti-ticket"></i>
            {{ inscrevendo ? "Inscrevendo..." : "Inscrever-se nesta atividade" }}
          </button>
        </div>
      </template>
    </template>

    <ModalDeConfirmacao v-if="modalConfirmacao.visivel" :texto="modalConfirmacao.mensagem"
      @confirmacao="tratarConfirmacao" />
  </div>

  <GestaoDeEquipe v-if="editarCargos" :acaoId="acaoIdAlvo" :atividadeId="atividadeIdAlvo"
    @fecharGestaoDeEquipe="editarCargos = false" />

  <ListaInscritos v-if="mostrarModalInscritos" :atividadeId="atividadeIdAlvo" :isCoordenador="coordenador"
    :criterioInscricao="dadosAtividade.criterioInscricao" @fechar="mostrarModalInscritos = false"
    @atualizar="carregarAtividade" />

  <RouterView />

  <FrequenciaEncontro v-if="modalAtual === 'realizarFrequencia' && !carregando && atividade" :atividade="atividade"
    :encontros="encontros" :nome-subtipo="nomeSubtipo" @fechar="fecharModal" />

  <FormEditarAtividade v-if="mostrarFormEdicao" :dados="atividade" :atividadeId="atividadeIdAlvo" :acaoId="acaoIdAlvo"
    :abrirEncontrosDireto="modalAtual === 'editarEncontros'" @fechar-form-atividade="fecharModalERecarregar" />

  <ModalLoginObrigatorio :visivel="mostrarModalLogin" :nomeAtividade="dadosAtividade.nome"
    @fechar="mostrarModalLogin = false" />

  <ModalFotosEncontro v-if="modalFotosVisivel" :visivel="modalFotosVisivel" :encontro="encontroSelecionadoFotos"
    :coordenador="coordenador" @fechar="fecharModalFotos" />
  <ModalDeAviso v-if="mostrarModalAvisoEmail" :sucesso="false"
    :texto="'Seu cadastro está incompleto. Atualize seu endereço de e-mail para realizar inscrições nas atividades.'"
    @fecharModal="mostrarModalAvisoEmail = false" />
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";

import GestaoDeEquipe from "@/components/atividades/GestaoDeEquipe.vue";
import FormEditarAtividade from "@/components/atividades/FormEditarAtividade.vue";
import ListaInscritos from "@/components/atividades/ListaInscritos.vue";
import FrequenciaEncontro from "@/components/encontros/FrequenciaEncontro.vue";
import EncontrosListagemAtividade from "@/components/encontros/EncontrosListagemAtividade.vue";
import ModalFotosEncontro from "@/components/encontros/ModalFotosEncontro.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import Carregamento from "@/components/common/Carregamento.vue";
import ModalDeConfirmacao from "@/components/common/modalDeConfirmacao.vue";
import ModalLoginObrigatorio from "@/components/common/ModalLoginObrigatorio.vue";
import ModalDeAviso from "@/components/common/aviso.vue";

import { formatarData, formatarDataHora, formatarEnum } from "@/utils/FormatarEntradas";
import userInfos from "@/utils/userInfos";
import { useAtividades } from "@/composables/useAtividades";
import { useToast } from "@/composables/useToast";
import acaoService from "@/service/acaoService";
import atividadeService from "@/service/atividadeService";
import usuarioService from "@/service/usuariosService"
import certificadoService from "@/service/certificadoService.js";
import encontrosService from "@/service/encontrosService.js";
import frequenciaService from "@/service/frequenciaService";
import participantesAtividadeService from "@/service/participantesAtividadeService";

const props = defineProps({
  acaoId: String,
  atividadeId: String,
});

defineEmits(["titulo", "fechar-atividade"]);
const mostrarModalAvisoEmail = ref(false);
const IMAGEM_PADRAO = "https://bucket.nerds.cloudns.be/gex-dev/imagemDefault.jpeg";
const LIMITE_SET_TIMEOUT = 2_147_483_647;

const SCOPES_ADMIN = ["SCOPE_ADMINISTRADOR", "ADMIN", "ADMINISTRADOR"];
const STATUS_ENCERRADOS = ["CANCELADA", "ENCERRADA", "FINALIZADO", "CONCLUIDA"];
const STATUS_ATIVOS = ["PROGRAMADA", "EM_EXECUCAO", "FINALIZANDO"];
const STATUS_ENCONTRO_PENDENTE = ["PROGRAMADO", "EM_EXECUCAO", "INSCRICOES_ABERTAS"];
const MODALIDADES_COM_FREQUENCIA = ["NESCESSITA_INSCRICAO", "NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA"];

const ROTULOS_MODALIDADE_INSCRICAO = {
  NAO_NESCESSITA_INSCRICAO_SEM_FREQUENCIA: "Não necessita de inscrição e sem frequência",
  NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA: "Não necessita de inscrição e com frequência",
  NESCESSITA_INSCRICAO_SEM_FREQUENCIA: "Necessita de inscrição e sem frequência",
  NESCESSITA_INSCRICAO: "Com inscrição",
};

const BADGES_STATUS = {
  INSCRICOES_ABERTAS: { classe: "aberta", icone: "ti-edit", texto: "Aberta" },
  EM_EXECUCAO: { classe: "em-andamento", icone: "ti-player-play", texto: "Em andamento" },
  PROGRAMADA: { classe: "programada", icone: "ti-calendar", texto: "Programada" },
  FINALIZADO: { classe: "concluida", icone: "ti-circle-check", texto: "Concluída" },
  CONCLUIDA: { classe: "concluida", icone: "ti-circle-check", texto: "Concluída" },
  CANCELADA: { classe: "cancelada", icone: "ti-circle-x", texto: "Cancelada" },
  ENCERRADA: { classe: "encerrada", icone: "ti-lock", texto: "Encerrada" },
  FINALIZANDO: { classe: "finalizando", icone: "ti-hourglass", texto: "Finalizando" },
};

const PERMISSAO_TOTAL = { coordenador: true, podeVerInscritos: true, coordenadorAcao: true };
const PERMISSAO_LIDER = { coordenador: true, podeVerInscritos: true, coordenadorAcao: false };
const SEM_PERMISSAO = { coordenador: false, podeVerInscritos: false, coordenadorAcao: false };

/* ────────────────────────────────────────────────────────────
 * Estado
 * ──────────────────────────────────────────────────────────── */
const toast = useToast();
const route = useRoute();
const { subtipo, fetchSubTipoPorId } = useAtividades();

const carregando = ref(true);
const atividade = ref(null);
const dadosAcao = ref(null);
const encontros = ref([]);
const nomeSubtipo = ref("");

const isInscrito = ref(false);
const inscrevendo = ref(false);
const processandoAcao = ref(false);
const baixandoCsv = ref(false);
const baixandoMapa = ref(false);

const coordenador = ref(false);
const podeVerInscritos = ref(false);
const isCoordenadorAcao = ref(false);

const editarCargos = ref(false);
const mostrarModalInscritos = ref(false);
const mostrarModalLogin = ref(false);
const modalFotosVisivel = ref(false);
const encontroSelecionadoFotos = ref(null);
const versaoEncontros = ref(0);
const imagemFalhou = ref(false);

const modalConfirmacao = ref({ visivel: false, tipo: "", mensagem: "" });
const atividadeIdAlvo = computed(
  () =>
    props.atividadeId ||
    route.params.atividadeId ||
    (!route.path.includes("/acao/") ? route.params.id : null) ||
    atividade.value?.id
);

const acaoIdAlvo = computed(
  () =>
    props.acaoId ||
    route.params.id ||
    atividade.value?.acaoExtensaoId ||
    atividade.value?.acaoId
);

const viaAcao = computed(() => !!route.params.id);
const modalAtual = computed(() => route.query.modal);
const dadosAtividade = computed(() => atividade.value || {});

const agora = ref(Date.now());
let temporizadorRelogio = null;

function agendarAtualizacaoDoRelogio() {
  clearTimeout(temporizadorRelogio);
  const agoraMs = Date.now();
  const marcos = [dadosAtividade.value.dataInicioInscricao, dadosAtividade.value.dataFimInscricao]
    .map((data) => (data ? new Date(data).getTime() : NaN))
    .filter((tempo) => !Number.isNaN(tempo) && tempo > agoraMs);

  if (!marcos.length) return;

  const espera = Math.min(Math.min(...marcos) - agoraMs + 500, LIMITE_SET_TIMEOUT);
  temporizadorRelogio = setTimeout(() => {
    agora.value = Date.now();
    agendarAtualizacaoDoRelogio();
  }, espera);
}

watch(
  () => [dadosAtividade.value.dataInicioInscricao, dadosAtividade.value.dataFimInscricao],
  () => {
    agora.value = Date.now();
    agendarAtualizacaoDoRelogio();
  },
  { immediate: true }
);

const necessitaInscricao = computed(
  () => dadosAtividade.value.modalidadeInscricao === "NESCESSITA_INSCRICAO"
);

const semInscricao = computed(() =>
  String(dadosAtividade.value.modalidadeInscricao || "").includes("NAO_NESCESSITA_INSCRICAO")
);

const temFrequencia = computed(() =>
  MODALIDADES_COM_FREQUENCIA.includes(dadosAtividade.value.modalidadeInscricao)
);

const isCriterioCoordenacao = computed(() =>
  ["CRITERIODACOORDENACAO", "CRITERIO_DA_COORDENACAO", "Critério da Coordenação"].includes(
    dadosAtividade.value.criterioInscricao
  )
);

const isAntesDeAbrirInscricao = computed(() => {
  if (!necessitaInscricao.value || !dadosAtividade.value.dataInicioInscricao) return false;
  const inicio = new Date(dadosAtividade.value.dataInicioInscricao).getTime();
  return !Number.isNaN(inicio) && agora.value < inicio;
});

const isPeriodoInscricaoEncerrado = computed(() => {
  if (!necessitaInscricao.value || !dadosAtividade.value.dataFimInscricao) return false;
  const fim = new Date(dadosAtividade.value.dataFimInscricao).getTime();
  return !Number.isNaN(fim) && agora.value > fim;
});

const statusEfetivo = computed(() => {
  const dados = dadosAtividade.value;
  if (dados.dataCancelamento) return "CANCELADA";
  if (dados.dataEncerramento) return "ENCERRADA";
  if (!dados.status) return "";

  const statusDefinitivos = [...STATUS_ENCERRADOS, "EM_EXECUCAO", "FINALIZANDO"];
  if (statusDefinitivos.includes(dados.status)) return dados.status;

  // Antes de abrir ou depois de fechar as inscrições, a atividade continua PROGRAMADA
  if (necessitaInscricao.value && (isAntesDeAbrirInscricao.value || isPeriodoInscricaoEncerrado.value)) {
    return "PROGRAMADA";
  }
  return dados.status;
});

const badgeStatus = computed(() => BADGES_STATUS[statusEfetivo.value] || null);
const statusEncerrado = computed(() => STATUS_ENCERRADOS.includes(statusEfetivo.value));
const statusAtivo = computed(() => STATUS_ATIVOS.includes(statusEfetivo.value));
const emExecucao = computed(() => ["EM_EXECUCAO", "FINALIZANDO"].includes(statusEfetivo.value));
const concluida = computed(() => ["FINALIZADO", "CONCLUIDA"].includes(statusEfetivo.value));

/* Vagas */
const vagasIlimitadas = computed(() => {
  const total = dadosAtividade.value.numeroDeVagasOfertadas;

  return (
    total == null ||
    total === "" ||
    Number(total) <= 0
  );
});

const vagasRestantes = computed(() => {
  const dados = dadosAtividade.value;

  return dados.vagaAbertas ?? dados.vagasAbertas ?? dados.vagasRestantes ?? null;
});

const isVagasEsgotadas = computed(
  () =>
    !vagasIlimitadas.value &&
    !isCriterioCoordenacao.value &&
    vagasRestantes.value !== null &&
    Number(vagasRestantes.value) === 0
);

const totalVagasTexto = computed(() =>
  vagasIlimitadas.value
    ? "Ilimitadas"
    : dadosAtividade.value.numeroDeVagasOfertadas
);

const vagasRestantesTexto = computed(() => {
  if (vagasIlimitadas.value) return "Ilimitadas";

  return vagasRestantes.value ?? totalVagasTexto.value;
});

const mostrarVagasRestantes = computed(
  () => vagasIlimitadas.value || vagasRestantes.value !== null
);

/* Inscrição do usuário */
const podeSeInscrever = computed(
  () =>
    !isInscrito.value &&
    necessitaInscricao.value &&
    !isVagasEsgotadas.value &&
    statusEfetivo.value === "INSCRICOES_ABERTAS"
);

const podeCancelarInscricao = computed(
  () => statusEfetivo.value === "INSCRICOES_ABERTAS" && !isPeriodoInscricaoEncerrado.value
);

const mostrarBadgeInscricoesEncerradas = computed(
  () => isPeriodoInscricaoEncerrado.value && statusEfetivo.value === "PROGRAMADA"
);

/* Banners */
const mostrarBannerInscrito = computed(() => isInscrito.value && !statusEncerrado.value);

const mostrarBannerInscricoesEncerradas = computed(
  () => mostrarBadgeInscricoesEncerradas.value && !isInscrito.value
);

const mostrarBannerProgramada = computed(
  () => statusEfetivo.value === "PROGRAMADA" && !isPeriodoInscricaoEncerrado.value && !isInscrito.value
);

const mostrarBannerInscricoesAbertas = computed(
  () =>
    statusEfetivo.value === "INSCRICOES_ABERTAS" &&
    !isInscrito.value &&
    !isPeriodoInscricaoEncerrado.value
);

const subtextoInscrito = computed(() => {
  const fim = formatarDataHora(dadosAtividade.value.dataFimInscricao);

  if (isPeriodoInscricaoEncerrado.value && statusEfetivo.value === "PROGRAMADA") {
    return isCriterioCoordenacao.value
      ? `O período de inscrições foi encerrado em ${fim}. A coordenação selecionará os participantes compatíveis com as vagas ofertadas.`
      : `O período de inscrições para esta atividade foi encerrado em ${fim}.`;
  }

  if (isCriterioCoordenacao.value && statusEfetivo.value === "INSCRICOES_ABERTAS") {
    return "Sua inscrição foi registrada com sucesso. Ao término do período de inscrições, a coordenação selecionará os participantes compatíveis com as vagas ofertadas.";
  }

  return "";
});

const textoBannerProgramada = computed(() => {
  if (dadosAtividade.value.dataInicioInscricao && isAntesDeAbrirInscricao.value) {
    return `As inscrições estão programadas para abrir dia ${formatarDataHora(
      dadosAtividade.value.dataInicioInscricao
    )}`;
  }
  return inicioRealizacaoTexto.value
    ? `A atividade está programada para iniciar dia ${inicioRealizacaoTexto.value}`
    : "A atividade está programada.";
});

/* Textos */
const explicacaoInscricao = computed(() => {
  const modalidade = dadosAtividade.value.modalidadeInscricao;

  if (!modalidade) {
    return "As informações sobre o funcionamento das inscrições não foram informadas.";
  }

  if (modalidade === "NAO_NESCESSITA_INSCRICAO_SEM_FREQUENCIA") {
    return "Esta atividade não necessita de inscrição e não possui controle de frequência.";
  }

  if (modalidade === "NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA") {
    return "Esta atividade não necessita de inscrição, mas possui controle de frequência.";
  }

  if (!necessitaInscricao.value) {
    return "Não é necessário realizar inscrição para participar desta atividade.";
  }

  if (isCriterioCoordenacao.value) {
    return "Os interessados podem se inscrever durante o período estabelecido. Após o encerramento das inscrições, a coordenação selecionará os participantes conforme os critérios definidos e o número de vagas disponíveis.";
  }

  if (dadosAtividade.value.criterioInscricao === "ORDEMDEINSCRICAO") {
    return "As vagas são preenchidas por ordem de inscrição. Os primeiros inscritos garantem a vaga até o limite de vagas disponíveis.";
  }

  return "É necessário realizar a inscrição durante o período estabelecido. Consulte as informações da atividade para conhecer os critérios de participação.";
});

const textoInscricao = computed(() => {
  if (isCriterioCoordenacao.value) return "Critério da coordenação";
  if (dadosAtividade.value.criterioInscricao === "ORDEMDEINSCRICAO") return "Ordem de inscrição";
  return formatarEnum(dadosAtividade.value.modalidadeInscricao);
});

const rotuloModalidadeInscricao = computed(
  () => ROTULOS_MODALIDADE_INSCRICAO[dadosAtividade.value.modalidadeInscricao] || ""
);


const nomeAcaoResponsavel = computed(() => {
  const tituloBruto =
    dadosAcao.value?.titulo ||
    dadosAcao.value?.nome ||
    dadosAtividade.value.acaoTitulo ||
    dadosAtividade.value.nomeAcao ||
    "";

  return String(tituloBruto).replace(/"/g, "").trim();
});
async function possuiEmailTemporario() {
  try {
    const response = await usuarioService.getUsuarioLogado();

    const email = String(response?.email || "")
      .trim()
      .toLowerCase();

    return email.endsWith("@gex.com");
  } catch (error) {
    console.error("Erro ao verificar e-mail do usuário:", error);
    return false;
  }
}
function avisarEmailTemporario() {
  mostrarModalAvisoEmail.value = true;
}

/* Datas */
function textoDeData(data) {
  return data ? formatarData(data) : "data não informada";
}

const inicioRealizacaoTexto = computed(() => {
  const inicio = encontros.value[0]?.inicio_periodo || dadosAtividade.value.dataInicioRealizacao;
  return inicio ? formatarData(inicio) : "";
});

const periodoRealizacao = computed(() => {
  const lista = encontros.value;

  if (lista.length) {
    const inicio = lista[0]?.inicio_periodo;
    const fim = lista[lista.length - 1]?.fim_periodo;

    return `Início: ${inicio ? formatarDataHora(inicio) : "A definir"}
Encerramento: ${fim ? formatarDataHora(fim) : "Sem data final"}`;
  }

  const {
    dataInicioRealizacao: inicio,
    dataFimRealizacao: fim,
  } = dadosAtividade.value;

  if (inicio && fim) {
    return `Início: ${formatarDataHora(inicio)}
Encerramento: ${formatarDataHora(fim)}`;
  }

  return "A definir";
});

const dataCancelamentoTexto = computed(() => {
  const d = dadosAtividade.value;
  return textoDeData(d.dataCancelamento || d.dataFimRealizacao || d.dataFimInscricao);
});

const dataEncerramentoTexto = computed(() => {
  const d = dadosAtividade.value;
  const ultimoEncontro = encontros.value[encontros.value.length - 1]?.fim_periodo;
  return textoDeData(d.dataEncerramento || d.dataFimRealizacao || ultimoEncontro || d.dataFimInscricao);
});

const dataConclusaoTexto = computed(() => {
  const d = dadosAtividade.value;
  return textoDeData(d.dataConclusao || d.dataEncerramento || d.dataFimRealizacao || d.dataFimInscricao);
});

/* Imagem e mapa */
const imagemAtividade = computed(() =>
  imagemFalhou.value || !dadosAtividade.value.imagemUrl ? IMAGEM_PADRAO : dadosAtividade.value.imagemUrl
);

watch(
  () => dadosAtividade.value.imagemUrl,
  () => {
    imagemFalhou.value = false;
  }
);

function aoFalharImagem() {
  imagemFalhou.value = true;
}

const temCoordenadas = computed(
  () => dadosAtividade.value.latitude != null && dadosAtividade.value.longitude != null
);

// Computed evita criar um array novo a cada render (o que reajustava o mapa)
const marcadoresMapa = computed(() => [
  { latitude: dadosAtividade.value.latitude, longitude: dadosAtividade.value.longitude },
]);

/* Painel do coordenador */
const mostrarBotoesEdicao = computed(() => coordenador.value && !statusEncerrado.value);

const podeRealizarFrequencia = computed(() => statusAtivo.value && temFrequencia.value);

const podeBaixarMapaFrequencia = computed(
  () =>
    statusEfetivo.value !== "CANCELADA" &&
    temFrequencia.value &&
    encontros.value.some((encontro) => encontro.status === "FINALIZADO")
);

const podeEscolherParticipantes = computed(
  () => statusAtivo.value && necessitaInscricao.value && isCriterioCoordenacao.value
);

const podeCriarEquipe = computed(() => statusAtivo.value);
const podeConcluirAtividade = computed(() => statusEfetivo.value === "EM_EXECUCAO");

const mostrarAcoesCoordenador = computed(
  () =>
    coordenador.value &&
    viaAcao.value &&
    (podeRealizarFrequencia.value ||
      podeBaixarMapaFrequencia.value ||
      podeEscolherParticipantes.value ||
      podeCriarEquipe.value ||
      podeConcluirAtividade.value)
);

const mostrarFormEdicao = computed(
  () => ["editarAtividade", "editarEncontros"].includes(modalAtual.value) && !!atividade.value
);

/* Breadcrumb */
const breadcrumbItems = computed(() => {
  const acaoId = route.params.id;
  const nome = dadosAtividade.value.nome || "Atividade";

  if (acaoId) {
    return [
      { label: "Início", to: "/" },
      { label: "Ações", to: "/suas-acoes" },
      { tipo: "acao", id: acaoId, to: `/acao/${acaoId}` },
      { label: "Atividades", to: `/acao/${acaoId}/atividades-acao` },
      { label: nome, to: `/acao/${acaoId}/atividades/${atividadeIdAlvo.value}` },
    ];
  }

  return [
    { label: "Início", to: "/" },
    { label: "Atividades", to: "/atividades" },
    { label: nome, to: `/atividades/${atividadeIdAlvo.value}` },
  ];
});

/* ────────────────────────────────────────────────────────────
 * Utilitários
 * ──────────────────────────────────────────────────────────── */
const mensagemDeErro = (erro, padrao) => erro?.response?.data?.message || erro?.message || padrao;

function formatarUrlExterna(url) {
  if (!url) return "#";
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}

function baixarArquivo(dados, tipo, nomeArquivo) {
  const url = window.URL.createObjectURL(new Blob([dados], { type: tipo }));
  const link = document.createElement("a");
  link.href = url;
  link.download = nomeArquivo;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

function isUsuarioAutenticado() {
  const user = userInfos.getUserInfos();
  const token = window.localStorage.getItem("auth_token");
  if (!user || !user.userId || !token) return false;
  return !userInfos.tokenExpirado(user);
}

const cacheCoordenadorAcao = new Map();
let sequenciaPermissao = 0;

function ehCoordenadorDaAcao(acaoId) {
  if (!cacheCoordenadorAcao.has(acaoId)) {
    cacheCoordenadorAcao.set(
      acaoId,
      (async () => {
        try {
          return !!(await acaoService.verificarCoordenador(acaoId));
        } catch (erro) {
          cacheCoordenadorAcao.delete(acaoId); // permite tentar de novo depois
          console.error("Erro ao verificar coordenador da ação:", erro);
          return false;
        }
      })()
    );
  }
  return cacheCoordenadorAcao.get(acaoId);
}

async function resolverPermissoes() {
  const user = userInfos.getUserInfos();
  if (!user) return SEM_PERMISSAO;

  const scopes = Array.isArray(user.scope) ? user.scope : String(user.scope || "").split(" ");

  // 1. Administradores e PREX têm acesso global
  if (scopes.some((escopo) => SCOPES_ADMIN.includes(escopo))) return PERMISSAO_TOTAL;

  // 2. Coordenador da ação desta atividade
  if (acaoIdAlvo.value && (await ehCoordenadorDaAcao(acaoIdAlvo.value))) return PERMISSAO_TOTAL;

  // 3. Líder desta atividade
  if (atividadeIdAlvo.value) {
    try {
      if (await userInfos.verificarLiderancaAtividade(atividadeIdAlvo.value)) return PERMISSAO_LIDER;
    } catch (erro) {
      console.error("Erro ao verificar se o usuário é líder:", erro);
    }
  }

  return SEM_PERMISSAO;
}

async function verificarPermissaoVerInscritos() {
  const sequencia = ++sequenciaPermissao;
  const permissoes = await resolverPermissoes();
  if (sequencia !== sequenciaPermissao) return; // chamada mais nova já assumiu

  coordenador.value = permissoes.coordenador;
  podeVerInscritos.value = permissoes.podeVerInscritos;
  isCoordenadorAcao.value = permissoes.coordenadorAcao;
}

/* ────────────────────────────────────────────────────────────
 * Carregamento de dados
 * ──────────────────────────────────────────────────────────── */
async function carregarSubtipo() {
  const dados = atividade.value;

  if (dados?.subtipoId) {
    try {
      await fetchSubTipoPorId(dados.subtipoId);
      nomeSubtipo.value = subtipo.value?.nome || "";
    } catch (erro) {
      console.error("Erro ao buscar subtipo por id:", erro);
      nomeSubtipo.value = "";
    }
    return;
  }

  nomeSubtipo.value = dados?.subtipo?.nome || "";
}

async function buscarDadosDaAtividade(id) {
  try {
    atividade.value = await atividadeService.getAtividadeId(id);
  } catch (erro) {
    console.error("Erro ao carregar atividade:", erro);
    return;
  }
  await carregarSubtipo();
}

async function analiseInscricao() {
  const id = atividadeIdAlvo.value;
  if (!id || !userInfos.getUserInfos()) {
    isInscrito.value = false;
    return;
  }

  try {
    isInscrito.value = !!(await participantesAtividadeService.isUsuarioLogadoInscrito(id));
  } catch (erro) {
    console.error("Erro ao analisar inscrição:", erro);
    isInscrito.value = false;
  }
}

async function buscarEncontros() {
  const id = atividadeIdAlvo.value;

  if (!id) {
    encontros.value = [];
    return;
  }

  try {
    encontros.value = (await encontrosService.getEncontros(0, 1000, id)) || [];
  } catch (erro) {
    console.error("Erro ao buscar encontros:", erro);
    encontros.value = [];
  }
}

async function carregarAtividade() {
  const id = atividadeIdAlvo.value;
  if (!id) return;

  // Consultas independentes rodam em paralelo
  await Promise.all([buscarDadosDaAtividade(id), analiseInscricao(), buscarEncontros()]);
}

async function carregarAcao() {
  if (!acaoIdAlvo.value) {
    dadosAcao.value = null;
    return;
  }

  try {
    dadosAcao.value = await acaoService.getAcoesById(acaoIdAlvo.value);
  } catch (erro) {
    console.error("Erro ao carregar dados da ação:", erro);
    dadosAcao.value = null;
  }
}

async function inicializar() {
  carregando.value = true;
  try {
    await carregarAtividade();
    await Promise.all([carregarAcao(), verificarPermissaoVerInscritos()]);
  } finally {
    carregando.value = false;
  }
}

/* ────────────────────────────────────────────────────────────
 * Navegação e modais
 * ──────────────────────────────────────────────────────────── */
async function abrirModal(modal) {
  // o status dos encontros muda com o tempo, então atualiza antes de abrir
  if (modal === "realizarFrequencia") await buscarEncontros();
  router.push({ query: { modal, atividade: atividadeIdAlvo.value } });
}

function fecharModal() {
  router.push({ query: {} });
}

function fecharModalERecarregar() {
  fecharModal();
  carregarAtividade();
}

function verInscritos() {
  mostrarModalInscritos.value = true;
}

function editarAtividade() {
  if (!acaoIdAlvo.value || !atividadeIdAlvo.value) {
    toast.erro("Não foi possível identificar a ação ou a atividade para edição.");
    return;
  }
  router.push({
    name: "editar-atividade",
    params: { id: acaoIdAlvo.value, atividadeId: atividadeIdAlvo.value },
  });
}

function abrirMapaTelaCheia() {
  const dados = dadosAtividade.value;
  router.push({
    path: "/mapa",
    query: {
      lat: dados.latitude,
      lng: dados.longitude,
      titulo: dados.nome || "Local da Atividade",
      subtitulo: dados.localLabel || dados.local || "",
      localLabel: dados.localLabel || "",
      local: dados.local || "",
      atividadeId: atividadeIdAlvo.value || null,
    },
  });
}

function abrirModalFotos(encontro) {

  encontroSelecionadoFotos.value = encontro;
  modalFotosVisivel.value = true;
}

function fecharModalFotos() {
  modalFotosVisivel.value = false;
  versaoEncontros.value++; // recria a listagem de encontros com as fotos atualizadas
}

/* ────────────────────────────────────────────────────────────
 * Confirmações (cancelar atividade, concluir atividade, cancelar inscrição)
 * ──────────────────────────────────────────────────────────── */
const acoesDeConfirmacao = {
  cancelar: executarCancelamentoDaAtividade,
  concluir: executarConclusaoDaAtividade,
  desinscrever: executarCancelamentoDaInscricao,
};

function abrirConfirmacao(tipo, mensagem) {
  modalConfirmacao.value = { visivel: true, tipo, mensagem };
}

async function tratarConfirmacao(confirmou) {
  const { tipo } = modalConfirmacao.value;
  modalConfirmacao.value.visivel = false;

  if (!confirmou || processandoAcao.value) return;

  processandoAcao.value = true;
  try {
    await acoesDeConfirmacao[tipo]?.();
  } finally {
    processandoAcao.value = false;
  }
}

function abrirModalCancelarAtividade() {
  abrirConfirmacao(
    "cancelar",
    `Tem certeza que deseja cancelar a atividade "${dadosAtividade.value.nome || ""}"?\nEssa ação não poderá ser desfeita.`
  );
}

function abrirModalCancelarInscricao() {
  if (!userInfos.getUserInfos()) return;
  abrirConfirmacao("desinscrever", "Deseja realmente cancelar sua inscrição nesta atividade?");
}

function abrirModalConcluirAtividade() {
  if (concluida.value) {
    toast.aviso("Esta atividade já foi concluída.");
    return;
  }

  if (statusEfetivo.value !== "EM_EXECUCAO") {
    toast.aviso("Somente atividades em execução podem ser concluídas.");
    return;
  }

  const pendentes = encontros.value.filter((encontro) => STATUS_ENCONTRO_PENDENTE.includes(encontro.status));
  if (pendentes.length) {
    const titulos = pendentes
      .map((encontro) => `• ${encontro.titulo || encontro.descricao || "Encontro sem título"}`)
      .join("\n");
    toast.aviso(
      `Não é possível concluir a atividade.\n\nOs seguintes encontros ainda estão pendentes:\n${titulos}\n\nConclua ou cancele todos os encontros antes de concluir a atividade.`,
      { duracao: 7000 }
    );
    return;
  }

  abrirConfirmacao(
    "concluir",
    `Deseja realmente concluir a atividade "${dadosAtividade.value.nome || ""}"?\nEssa ação irá alterar o status da atividade para Concluída.`
  );
}

async function executarCancelamentoDaAtividade() {
  try {
    const resposta = await atividadeService.cancelarAtividade(atividadeIdAlvo.value);
    if (!resposta) {
      toast.erro("Não foi possível cancelar a atividade. Tente novamente.");
      return;
    }
    toast.sucesso("Atividade cancelada com sucesso!");
    await router.push("/Atividades");
  } catch (erro) {
    console.error("Erro ao cancelar atividade:", erro);
    toast.erro(mensagemDeErro(erro, "Não foi possível cancelar a atividade. Tente novamente."));
  }
}

async function executarConclusaoDaAtividade() {
  try {
    await atividadeService.concluirAtividade(atividadeIdAlvo.value);
    await carregarAtividade();
    toast.sucesso("Atividade concluída com sucesso!");
  } catch (erro) {
    console.error("Erro ao concluir atividade:", erro);
    toast.erro(mensagemDeErro(erro, "Ocorreu um erro ao concluir a atividade. Tente novamente."));
  }
}

async function executarCancelamentoDaInscricao() {
  const user = userInfos.getUserInfos();
  const id = atividadeIdAlvo.value;
  if (!user || !id) return;

  try {
    await participantesAtividadeService.desinscreverUsuario(id, user);
    isInscrito.value = false;
    toast.info("Sua inscrição nesta atividade foi cancelada.", {
      titulo: "Inscrição cancelada",
      duracao: 5000,
    });
    await carregarAtividade();
  } catch (erro) {
    console.error("Erro ao cancelar inscrição:", erro);
    toast.erro(mensagemDeErro(erro, "Erro ao cancelar inscrição. Tente novamente."), {
      titulo: "Erro ao cancelar",
    });
  }
}

/* ────────────────────────────────────────────────────────────
 * Inscrição
 * ──────────────────────────────────────────────────────────── */
async function realizarInscricao() {
  if (!isUsuarioAutenticado()) {
    mostrarModalLogin.value = true;
    return;
  }
  // Impede inscrições de usuários com e-mail temporário
  if (await possuiEmailTemporario()) {
    avisarEmailTemporario();
    return;
  }
  if (inscrevendo.value) return;

  if (isPeriodoInscricaoEncerrado.value) {
    toast.aviso("O período de inscrições para esta atividade já foi encerrado.", {
      titulo: "Inscrições encerradas",
    });
    return;
  }

  if (isAntesDeAbrirInscricao.value) {
    toast.aviso("O período de inscrições para esta atividade ainda não foi iniciado.", {
      titulo: "Inscrições não iniciadas",
    });
    return;
  }

  if (isVagasEsgotadas.value) {
    toast.aviso("As vagas para esta atividade estão esgotadas.", {
      titulo: "Vagas esgotadas",
    });
    return;
  }




  const id = atividadeIdAlvo.value;

  if (!id) {
    toast.erro("Identificador da atividade não encontrado.", {
      titulo: "Erro",
    });
    return;
  }

  inscrevendo.value = true;

  try {
    await participantesAtividadeService.postParticipanteAtividade(
      userInfos.getUserInfos().userId,
      id
    );

    isInscrito.value = true;

    toast.sucesso("Inscrição realizada com sucesso!", {
      titulo: "Inscrição confirmada",
      duracao: 5000,
    });

    await carregarAtividade();
  } catch (erro) {
    console.error("Erro ao realizar inscrição:", erro);

    toast.erro(mensagemDeErro(erro, "Erro ao realizar inscrição. Tente novamente."), {
      titulo: "Não foi possível inscrever",
    });
  } finally {
    inscrevendo.value = false;
  }
}

/* ────────────────────────────────────────────────────────────
 * Downloads
 * ──────────────────────────────────────────────────────────── */
async function baixarCsvFrequencia() {
  if (baixandoCsv.value) return;
  baixandoCsv.value = true;

  try {
    const resposta = await certificadoService.exportarAprovadosPlanilha(atividadeIdAlvo.value);
    const dados = resposta?.data || resposta;
    if (!dados) return;

    const nomeSanitizado = String(dadosAtividade.value.nome || "")
      .trim()
      .replace(/[\\/:*?"<>|]/g, "")
      .replace(/\s+/g, "_");

    baixarArquivo(
      dados,
      "text/csv;charset=utf-8;",
      nomeSanitizado ? `participantes_aprovados_${nomeSanitizado}.csv` : "participantes_aprovados.csv"
    );
  } catch (erro) {
    console.error("Erro ao baixar CSV:", erro);
    toast.erro("Erro ao baixar CSV de frequência.");
  } finally {
    baixandoCsv.value = false;
  }
}

async function baixarMapaFrequencia() {
  if (baixandoMapa.value) return;
  baixandoMapa.value = true;

  try {
    const id = atividadeIdAlvo.value;
    const dados = await frequenciaService.baixarMapaDeFrequencia(id);
    if (dados) {
      baixarArquivo(
        dados,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        `mapa_frequencia_${id}.xlsx`
      );
    }
  } catch (erro) {
    console.error("Erro ao baixar mapa de frequência:", erro);
    toast.erro("Erro ao baixar mapa de frequência. Tente novamente.");
  } finally {
    baixandoMapa.value = false;
  }
}

/* ────────────────────────────────────────────────────────────
 * Ciclo de vida
 * ──────────────────────────────────────────────────────────── */
// A chave é uma string: o watch só dispara quando algum id realmente muda
// (e não ao abrir/fechar modais via query string).
const chaveDaRota = computed(() =>
  [props.atividadeId, route.params.atividadeId, route.params.id].join("|")
);

watch(chaveDaRota, () => {
  atividade.value = null;
  encontros.value = [];
  inicializar();
});

onMounted(inicializar);

onUnmounted(() => {
  clearTimeout(temporizadorRelogio);
});
</script>

<style scoped>
/* ── Cabeçalho ───────────────────────────────────────────── */
#top-content-atividade {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

#titulo-e-acoes {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  margin-bottom: 2rem;
}

#titulo-atividade {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

#titulo-atividade h2 {
  margin-bottom: 0;
  overflow-wrap: anywhere;
}

.status-badge-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.header-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  flex-shrink: 0;
}

#botoes-coordenador,
#botoes-coordenador-encerrada,
.inscricao-topo-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

/* ── Badges de status ────────────────────────────────────── */
.status-atividade {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 99px;
  font-size: 0.82rem;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  box-sizing: border-box;
}

.em-andamento {
  background-color: var(--verde-claro);
  color: var(--verde-escuro);
}

.programada,
.finalizando {
  background-color: var(--cinza-claro);
  color: var(--cinza-escuro);
}

.concluida,
.encerrada {
  background-color: var(--verde-claro);
  color: var(--verde-escuro);
}

.cancelada {
  background-color: var(--vermelho-claro);
  color: var(--vermelho-escuro);
}

.aberta {
  background-color: var(--roxo-superficie);
  color: var(--roxo-primario);
}

.inscricoes-encerradas {
  background-color: var(--laranja-claro);
  color: var(--laranja-escuro);
}

.badge-inscrito-topo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  background-color: var(--verde-claro);
  color: var(--verde-escuro);
  border: 1.5px solid var(--verde-claro);
  border-radius: 99px;
  font-size: 0.85rem;
  font-weight: 700;
  white-space: nowrap;
}

/* ── Botões ──────────────────────────────────────────────── */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 20px;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  box-sizing: border-box;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-pequeno {
  height: 32px;
  padding: 0 12px;
  font-size: 0.8rem;
}

.btn-bloco {
  width: 100%;
}

.btn-primario {
  background-color: var(--roxo-primario);
  color: var(--branco);
}

.btn-primario:hover:not(:disabled) {
  background-color: var(--roxo-medio);
  color: var(--branco);

}

.btn-destaque {
  background-color: var(--roxo-primario);
  color: var(--branco);
  box-shadow: 0 2px 6px hsla(258, 46%, 46%, 0.25);
}

.btn-destaque:hover:not(:disabled) {
  background-color: var(--roxo-medio);
  color: var(--branco);
  transform: translateY(-1px);
}

.btn-perigo {
  background-color: var(--vermelho-escuro);
  color: var(--branco);
}

.btn-perigo:hover:not(:disabled) {
  background-color: var(--vermelho);
  color: var(--branco);
}

.btn-perigo-suave {
  background-color: var(--vermelho-claro);
  color: var(--vermelho-escuro);
  border: 1.5px solid var(--vermelho-claro);
}

.btn-perigo-suave:hover:not(:disabled) {
  border-color: var(--vermelho);
  transform: translateY(-1px);
}

.btn-sucesso {
  background-color: var(--verde-escuro);
  color: var(--branco);
}

.btn-sucesso:hover:not(:disabled) {
  background-color: var(--verde);
  color: var(--branco);
}

/* ── Estrutura da página ─────────────────────────────────── */
#conteudo {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: auto;
}

#superior {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
}

#esquerda {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 55%;
}

#direita {
  width: 44%;
}

#inferior {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1rem;
  width: 100%;
  margin-top: 2rem;
}

.rotulo-secao {
  display: block;
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--roxo-primario);
}

/* ── Imagem ──────────────────────────────────────────────── */
#img {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  max-width: 100%;
  height: 500px;
  overflow: hidden;
  background-color: var(--branco);
  border-radius: 16px;
  flex-shrink: 0;
}

#img figure {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

#img img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/* ── Coordenação (abaixo da imagem) ──────────────────────── */
.bloco-formulario-coordenacao {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.infos-rodape {
  padding-top: 12px;
  border-top: 1px solid var(--cinza-claro);
}

.infos-rodape-sozinho {
  padding-top: 0;
  border-top: none;
}

#acoes-coordenador {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

#opcoes {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 10px;
}

.link-formulario-externo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--roxo-medio);
  font-size: 0.88rem;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s ease;
}

.link-formulario-externo:hover {
  color: var(--roxo-primario);
  text-decoration: underline;
}

/* ── Informações ─────────────────────────────────────────── */
#infos {
  width: 100%;
}

.infos-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
}

.info-item {
  display: flex;
  flex-direction: column;
}



.info-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--cinza-escuro);
}

.info-label i {
  font-size: 0.9rem;
  color: var(--roxo-medio);
}

.info-value {
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cinza-escuro);
  white-space: pre-line;
}

.info-complemento {
  margin: 4px 0 0;
}

.vagas-esgotadas {
  color: var(--vermelho);
  font-weight: 700;
}


.info-explicacao-texto {
  font-size: 0.84rem;
  line-height: 1.45;
}

.link-acao-responsavel {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: var(--preto);
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
}

.link-acao-icone {
  font-size: 0.9em;
  opacity: 0.7;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.link-acao-responsavel:hover {
  color: var(--roxo-claro);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.link-acao-responsavel:hover .link-acao-icone {
  opacity: 1;
  transform: translate(2px, -2px);
}

.link-acao-responsavel:focus-visible {
  outline: 2px solid var(--roxo-claro);
  outline-offset: 3px;
  border-radius: 2px;
}

.btn-tela-cheia-mapa {

  padding: 5px 10px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0;
  color: var(--branco);
  background-color: var(--roxo-primario);
  border-radius: 50px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.btn-tela-cheia-mapa:hover {
  background-color: var(--roxo-medio);
  color: #ffffff;
}

/* ── Descrição e objetivos ───────────────────────────────── */
#descricao {
  display: block;
  overflow: hidden;
  font-size: 0.95rem;
  line-height: 1.6;
  text-align: justify;
  word-break: break-word;
  overflow-wrap: anywhere;
}

#conteudo-descricao {
  display: inline;
  width: 100%;
  font-weight: 400;
  color: var(--cinza-escuro);
  word-break: break-word;
  overflow-wrap: anywhere;
}

#objetivos-relacionados {
  margin-top: 1rem;
  margin-bottom: 24px;
}

.objetivo-relacionado-item {
  margin-top: 12px;
  padding: 12px 16px;
  background-color: var(--branco);
  border-left: 4px solid var(--roxo-medio);
  border-radius: 4px;
}

.objetivo-titulo {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--preto);
}

.objetivos-vazio {
  margin: 12px 0 0;
  font-size: 0.9rem;
  color: var(--cinza-escuro);
}

/* ── Banners de status ───────────────────────────────────── */
.confirmacao {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 100%;
  margin: 24px 0;
  padding: 18px 24px;
  background-color: var(--roxo-superficie);
  border: 1.5px solid var(--roxo-superficie);
  border-radius: 12px;
  box-sizing: border-box;
}

.confirmacao-mensagem {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}

.confirmacao-texto-bloco {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
}

.confirmacao-titulo {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}

.confirmacao-subtexto {
  margin: 0;
  font-size: 0.86rem;
  font-weight: 400;
  line-height: 1.4;
  color: var(--cinza-escuro);
}

.confirmacao-inscrito,
.confirmacao-aberta,
.confirmacao-erro {
  justify-content: space-between;
  padding: 16px 24px;
}

.confirmacao-inscrito {
  background-color: var(--verde-claro);
  border-color: var(--verde-claro);
}

.confirmacao-inscrito .confirmacao-titulo {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--verde-escuro);
}

.confirmacao-inscrito .confirmacao-subtexto {
  font-weight: 500;
  color: var(--verde-escuro);
}

.confirmacao-inscricoes-encerradas {
  background-color: var(--laranja-claro);
  border-color: var(--laranja-claro);
}

.confirmacao-inscricoes-encerradas .confirmacao-titulo {
  color: var(--laranja-escuro);
}

.confirmacao-inscricoes-encerradas .confirmacao-subtexto {
  color: var(--laranja);
}

.confirmacao-aberta .confirmacao-titulo {
  color: var(--roxo-primario);
}

.confirmacao .confirmacao-titulo-alerta {
  color: var(--vermelho);
}

.confirmacao-erro {
  background-color: var(--vermelho-claro);
  border-color: var(--vermelho-claro);
}

.confirmacao-erro .confirmacao-titulo {
  color: var(--vermelho-escuro);
}

/* ── Responsivo ──────────────────────────────────────────── */
@media (max-width: 900px) {
  #img {
    width: 100%;
    min-height: 260px;
    height: 280px;
  }
}

@media (max-width: 768px) {
  #titulo-e-acoes {
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .header-actions {
    width: 100%;
  }

  .inscricao-topo-container {
    width: 100%;
    gap: 0;
    justify-content: space-between;
  }

  #superior {
    flex-direction: column;
    gap: 1rem;
  }

  #esquerda,
  #direita {
    width: 100%;
  }

  #inferior {
    gap: 24px;
  }

  .confirmacao-aberta {
    flex-direction: column;
    align-items: stretch;
  }
}

@media (max-width: 480px) {
  .infos-grid {
    grid-template-columns: 1fr;
  }
}
</style>